import { tv } from '@/ui/utils'

/**
 * The brand's chrome: a back arrow or a close cross at the edges, the wordmark centred, and —
 * where a flow has steps — a measure beneath it, filling left to right.
 *
 * The measure is the score's band: a rounded blush track with a coral fill, held inside the
 * page's own margins. Bled to the screen's edges it read as a browser's loading bar; inset and
 * rounded it reads as the one the app already draws under every score.
 */
export const flowHeaderStyles = tv({
	slots: {
		bar: 'relative h-14 lg:h-[88px] w-full flex-row items-center justify-between px-4 lg:px-14 bg-ground',
		side: 'min-w-12 flex-row items-center',
		logoWrap: 'absolute inset-0 items-center justify-center pointer-events-none',
		logo: 'h-7 w-[84px] lg:h-10 lg:w-[120px]',
		progressTrack: 'mx-4 lg:mx-14 mb-1 h-1.5 overflow-hidden rounded-full bg-blush',
		progressFill: 'h-full rounded-full bg-accent',
	},
})
